import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M12.6 7A5.6 5.6 0 111.4 7a5.6 5.6 0 0111.2 0zm.7 0A6.3 6.3 0 11.7 7a6.3 6.3 0 0112.6 0zM7 3.15h-.7v3.645l2.902 2.903.495-.495-2.698-2.698V3.15z" fill="#000" /></svg>;